import React from 'react';
import { Body1Strong, makeStyles, Text } from '@fluentui/react-components';
import NoSelectionsIcon from './no-selections-icon';
import { I18n } from '../types';

const useStyles = makeStyles({
  wrapper: {
    textAlign: 'center',
    paddingTop: '40px',
    paddingBottom: '40px',
  },
  message: {
    textAlign: 'center',
    display: 'block',
  },
});

const NoSelectionsMessage = ({ i18n }: { i18n: I18n }) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <NoSelectionsIcon alt={i18n.getString(_TL_('No selections icon'))} />
      <Body1Strong className={classes.message}>{i18n.getString(_TL_('You haven’t selected anything yet.'))}</Body1Strong>
      <Text>{i18n.getString(_TL_('Once you make selections, you’ll see them here.'))}</Text>
    </div>
  );
};

export default NoSelectionsMessage;
